import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import FormQuestionToApi from "../../atoms/form-question-to-api/form-question-to-api"
import FormQuestionWebToCase from "../../atoms/form-question-web-to-case/form-question-web-to-case"

import "./form-question.scss"

const FormQuestion = props => {
  const { title } = props
  const resultQuery = useStaticQuery(
    graphql`
      query TYC_QUERY {
        allContentfulNolFooter {
          nodes {
            node_locale
            politicaPrivacidadDatos
            terminosYCondiciones
            redireccionPoliticaPrivacidadDatos
            redireccionTerminosYCondiciones
          }
        }
      }
    `
  )

  // const urlTerminosCondiciones = resultQuery.allContentfulNolFooter.nodes.filter(
  //   e => e.node_locale === process.env.LOCALE
  // )[0].redireccionTerminosYCondiciones
  // const urlPoliticaPrivacidadDatos = resultQuery.allContentfulNolFooter.nodes.filter(
  //   e => e.node_locale === process.env.LOCALE
  // )[0].redireccionPoliticaPrivacidadDatos

  return process.env.LOCALE === "es-AR" ? (
    <FormQuestionToApi titleForm = {title} />
  ) : (
    <FormQuestionWebToCase titleForm = {title} />
  )
}

export default FormQuestion
